import { SEARCH } from '../actions/search';

const initialState = {
  searchedByForm: false,
};

export const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH:
      return {
        searchedByForm: action.payload.searchedByForm,
      };

    default:
      return state;
  }
};
